export default "__VITE_ASSET__BrnPwZ5g__"